import { axiosApi } from "../axios/axios_config";
export async function getAudioaware(pagination, filter) {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const studyNumber = localStorage.getItem("studyNumber");
  let endpoint = `audioaware?userId=${userInfo.id}`;

  if(studyNumber){
    endpoint += `&studyNumber=${studyNumber}`;
  }
  
  // if (filter && filter.filterBy && filter.filterValue) {
  //   endpoint += `&filterBy=${filter.filterBy}&filterValue=${filter.filterValue}`;
  // }
  let body = {};
  if (filter && Object.keys(filter).length > 0) {
    const filterObj = {}
    if (filter?.UserId && filter?.UserId.length) {
      filterObj['UserId'] = filter.UserId;
    }
    if (filter?.StudyNumber && filter?.StudyNumber.length) {
      filterObj['StudyNumber'] = filter.StudyNumber;
    }
    if (filter?.PatientId && filter?.PatientId.length) {
      filterObj['PatientId'] = filter.PatientId;
    }
    if (filter?.createdDateRange) {
      filterObj['createdDateRange'] = filter.createdDateRange;
    }
    if (filter?.tubeId) {
      filterObj['tubeId'] = filter.tubeId;
    }
    body = JSON.stringify({ filter: filterObj });
  }


  if (pagination?.pageIndex && pagination?.pageSize) {
    endpoint += `&pageIndex=${pagination.pageIndex}&pageSize=${pagination.pageSize}`;
  }
  try {
    const { data, response } = await axiosApi({
      endpoint: endpoint,
      method: "POST",
      bodyData: body ? body : null
    });
    return { data, response };
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
